import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { CopyIcon, Trash2Outline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { RelatedEntityTypeEnum } from '@/types/schema';

export enum ActionItemActions {
  Delete = 'DELETE',
  Duplicate = 'DUPLICATE',
}

export const getActionMenuItems = (
  t: TFunction,
  entityType?: RelatedEntityTypeEnum,
): ActionMenuItemType[] => {
  return getEnabledItems<
    ActionMenuItemType & {
      enabled: boolean;
    }
  >([
    {
      label: t('Common:Actions.Duplicate'),
      appearance: 'primary',
      EndIcon: CopyIcon,
      id: ActionItemActions.Duplicate,
      enabled:
        !!entityType &&
        [RelatedEntityTypeEnum.MeetingInstance, RelatedEntityTypeEnum.AgendaItem].includes(
          entityType,
        ),
    },
    {
      label: t('Common:Actions.Delete'),
      appearance: 'danger',
      EndIcon: Trash2Outline,
      enabled: true,
      id: ActionItemActions.Delete,
    },
  ]);
};
